var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMarioFlower = _ref => {
  let {
    className,
    height = 48,
    titleId,
    title,
    ref,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1,7.5a6.75,6.75,0,0,1-6.75,6.75h-4.5a6.75,6.75,0,0,1,0-13.5h4.5A6.75,6.75,0,0,1,23.1,7.5Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,7.5a3.75,3.75,0,0,1-3.75,3.75h-4.5a3.75,3.75,0,0,1,0-7.5h4.5A3.75,3.75,0,0,1,20.1,7.5Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.099 6.75L17.099 8.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.099 6.75L11.099 8.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.099 14.25L10.349 23.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,23.25H5.2a3,3,0,0,1-2.5-1.336l-1.332-2A.75.75,0,0,1,2,18.75H3.493a3,3,0,0,1,2.5,1.336Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,23.25h2.894a3,3,0,0,0,2.5-1.336l1.332-2A.75.75,0,0,0,20.2,18.75H18.7a3,3,0,0,0-2.5,1.336Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
export const Icon = _ref2 => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 48,
    titleId,
    title,
    ref,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1,7.5a6.75,6.75,0,0,1-6.75,6.75h-4.5a6.75,6.75,0,0,1,0-13.5h4.5A6.75,6.75,0,0,1,23.1,7.5Z",
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,7.5a3.75,3.75,0,0,1-3.75,3.75h-4.5a3.75,3.75,0,0,1,0-7.5h4.5A3.75,3.75,0,0,1,20.1,7.5Z",
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.099 6.75L17.099 8.25",
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.099 6.75L11.099 8.25",
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.099 14.25L10.349 23.25",
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,23.25H5.2a3,3,0,0,1-2.5-1.336l-1.332-2A.75.75,0,0,1,2,18.75H3.493a3,3,0,0,1,2.5,1.336Z",
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,23.25h2.894a3,3,0,0,0,2.5-1.336l1.332-2A.75.75,0,0,0,20.2,18.75H18.7a3,3,0,0,0-2.5,1.336Z",
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
};
export default SvgIconMarioFlower;
export const raw = __webpack_public_path__ + "static/media/IconMarioFlower.b1c6b6c3c3b220a32854b8f68595ce8b.svg";